<template>
	<div class="top_hads">
		<div class="header_head">
			<div class="w cle">
				<div class="logo fl">
					<a href="#">
						<img src="../../static/img1.jpg" />
					</a>
				</div>
				<div class="serch fl">

					<input type="text" placeholder="" class="text" v-model="searchVlaue" />
					<input type="button" value="" class="but" @click="openurlSearch" />

				</div>

				<div class="fr lang" @mouseover="shownavs">
					<span class="en">
						{{sel_country_info.shortWord}}
					</span>
					<dl id="wotnasnav">

						<dd v-for="(item,index) in country_list" @click="selCountry(item)">
							{{item.shortWord}}
						</dd>
					</dl>
				</div>

			</div>
		</div>

		<div class="nav " :class="banner == 2 ? 'nav_pro' : ''">
			<div class="w">
				<ul>
					<li :class="pageindex == 1 ? 'more' : ''">
						<router-link to='/home'>
							<a href="#" class="li_a">
								Home
							</a>
						</router-link>
					</li>
					<li :class="pageindex == 2 || pageindex == 8 ? 'more' : ''" @click="toPro">
						<router-link to='/proudct'>
							<a href="#" class="li_a">
								Products
							</a>
						</router-link>
					</li>
					<li :class="pageindex == 3 ? 'more' : ''">
						<router-link to='/about'>
							<a href="#" class="li_a">
								About US
							</a>
						</router-link>
					</li>
				</ul>
			</div>
		</div>

		<div v-if="banner == 2 ? false : true">
			<div class="index_banner" v-if="banner == 1 ? true : false">

			</div>

			<div class="c_banner" v-if="banner == 1 ? false : true">

			</div>
		</div>

    <div v-if="pageindex == 8 || pageindex == 2 ? false : true  ">
      <div class="groups_list cle" :class="banner == 1 || banner == 2 ? 'index_group_list' : ''">
        <div class="w cle">
          <div class="item fl">
            <div class="dm">
              <div class="img">
                <img src="../../static/p37.png" />
              </div>
              <div class="con">
                <div class="nt txtov">
                  Apply
                </div>
                <div class="dect">
                  Search product keywords(product name) to find out the items on amazon.(If you couldn't find it, please contact customer)
                </div>
                <img src="../../static/p9.png" class="icon" />
              </div>
            </div>
          </div>
          <div class="item fl">
            <div class="dm">
              <div class="img">
                <img src="../../static/p38.png" />
              </div>
              <div class="con">
                <div class="nt txtov">
                  Order
                </div>
                <div class="dect">
                  Add to cart and view some similar products, send order screenshot to customer as soon as ordered.
                </div>
                <img src="../../static/p9.png" class="icon" />
              </div>
            </div>
          </div>
          <div class="item fl">
            <div class="dm">
              <div class="img">
                <img src="../../static/p39.png" />
              </div>
              <div class="con">
                <div class="nt txtov">
                  Review
                </div>
                <div class="dect">
                  Write product review  and reviews should be completed after 5-7 days of the date the product received.
                </div>
                <img src="../../static/p9.png" class="icon" />
              </div>
            </div>
          </div>
          <div class="item fl">
            <div class="dm">
              <div class="img">
                <img src="../../static/p40.png" />
              </div>
              <div class="con">
                <div class="nt txtov">
                  Refund
                </div>
                <div class="dect">
                  Get cashback directly to your PayPal account within 24 working hours.
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

		<!--  -->

		<!--加载中的动画-->
		<div v-if="pageindex == 3 ? false : true">
			<div v-if="logding">


				<div id="Loading">
					<div class="loader-inner ball-beat">
						<div></div>
						<div></div>
						<div></div>
					</div>

				</div>
				<div class="zzxx"></div>


			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'HerderHead',
		props: {
			banner: Number,
			pageindex: Number
		},

		data() {
			return {
				data: '',
				hei: null,
				country_list: [], //国家列表
				sel_country_info: window.localStorage.getItem("country_name"),
				searchVlaue: '', //搜索值
				logding: true
				// sel_coutry: window.localStorage.setItem("name","张三")
			}
		},
		methods: {
			way(e) {
				console.log('子组件内的方法');
				console.log(e);
				this.searchVlaue = e;
			},
			//选择城市
			selCountry(row) {
				var that = this;
				that.sel_country_info = row;
				window.localStorage.setItem("country_name", JSON.stringify(row));

				if (that.$parent.goBack) {
					that.$parent.goBack(that.sel_country_info);
				}

				document.getElementById("wotnasnav").style.display = "none";



			},
			//搜索跳转
			openurlSearch() {
				var that = this;
				console.log(that.searchVlaue);
				if (that.pageindex == 8) {
					console.log('搜索');

					this.$parent.fatherMethod(that.sel_country_info.station, that.searchVlaue);

				} else {
					if (that.searchVlaue) {
						this.$router.push({
							path: '/search',
							// name: 'mallList',
							query: {
								wordKey: that.searchVlaue,
								guojia: that.sel_country_info.station
							}
						})
					} else {


						this.$router.push({
							path: '/search',
							// name: 'mallList',
							query: {
								wordKey: '',
								guojia: that.sel_country_info.station
							}
						})
						//alert('请输入关键词')



					}
				}


			},
			//打开加载框
			opensloding() {
				var that = this;
				that.logding = true;
				setTimeout(function() {
					that.logding = false;
				}, 1000)
			},
			shownavs() {
				document.getElementById("wotnasnav").style.display = 'block'
			},
			toPro(){
				window.localStorage.setItem("product_start", null)
			}



		},
		mounted() {

		},
		created() {
			var that = this;
			//window.localStorage.clear();

			this.$axios.get('station/list?pageNum=1&pageSize=100', {})
				.then(function(response) {
					that.country_list = response.data.data.list;
					console.log(window.localStorage.getItem("country_name"));
					if (window.localStorage.getItem("country_name") == null) {
						console.log('到这里了吗');
						that.$nextTick(function() {
							that.sel_country_info = response.data.data.list[0];
							window.localStorage.setItem("country_name", JSON.stringify(that.sel_country_info));
							that.$parent.getCouname(that.sel_country_info);
						})


					} else {
						var pres = window.localStorage.getItem("country_name")
						console.log(JSON.parse(pres));
						that.sel_country_info = JSON.parse(pres);
						that.$parent.getCouname(JSON.parse(pres));

					}
					setTimeout(function() {
						that.logding = false;
					}, 1000)

				})
				.catch(function(error) {});

			//console.log(window.localStorage.getItem("country_name"));



			console.log(this.$route.query.row);

		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.header_head {
		background: #333333;
		padding: 10px 0;

	}

	.header_head .serch {
		background: #fff;
		margin-left: 145px;
		height: 40px;
		border-radius: 4px;
		width: 850px;
		padding: 0px 10px;
		position: relative;
	}

	.header_head .serch .text {
		height: 40px;
		border-radius: 4px;
		width: 100%;
	}

	.header_head .serch .but {
		position: absolute;
		width: 55px;
		background: url(../../static/img2.jpg) center no-repeat #0b6cb6;
		border-radius: 0px 4px 4px 0;
		height: 100%;
		right: 0px;
		top: 0px;

	}

	.header_head .lang {
		/* background: url(../../static/img3.jpg) left center no-repeat;
		padding-left: 30px; */
		color: #fff;
		margin-top: 10px;
		font-size: 12px;
		position: relative;
		cursor: pointer;
	}

	.header_head .lang dl {
		display: none;
		position: absolute;
		z-index: 99;
		background: #333333;
		width: 100%;
	}

	.header_head .lang dl dd {
		padding: 5px 10px;
	}

	.header_head .lang dl dd:hover {
		background: #fff;
		color: #333;
	}

	.header_head .lang:hover dl {
		display: block;
	}

	.header_head .lang .en {
		background: url(../../static/p31.png) right center no-repeat;
		padding-right: 20px;
	}

	.nav {
		text-align: center;
		padding: 15px 0;
	}

	.nav ul li {
		display: inline-block;
		margin: 0px 50px;
	}

	.nav ul li .li_a {
		font-size: 14px;
		color: #080808;
	}

	.nav ul .more .li_a {

		color: #0b6cb6;
		font-weight: bold;
	}

	.nav ul li .li_a:hover {
		color: #0b6cb6;
	}

	.c_banner {
		height: 283px;
		position: relative;
		width: 100%;
		background: url(../../static/img4.jpg) center no-repeat;
	}

	.groups_list {
		background: #f2f2f2;
		padding: 60px 0px 50px;
	}

	.groups_list .item {
		width: 25%;
	}

	.groups_list .item .dm {
		display: flex;

		position: relative;
	}

	.groups_list .item .dm .img {
		width: 75px;
	}

	.groups_list .item .dm .con {
		flex: 1;
		padding-left: 10px;
		padding-right: 90px;
	}

	.groups_list .item .dm .con .nt {
		font-size: 18px;
		color: #393939;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.groups_list .item .dm .con .dect {
		color: #393939;
		font-size: 14px;
	}

	.groups_list .item .dm .con .icon {
		position: absolute;
		right: 30px;
		top: 50%;
		transform: translate(0, -50%);
	}

	.index_banner {
		background: url(../../static/p34.jpg) center no-repeat;
		background-size: cover;
		height: 582px;
	}

	.index_group_list {
		background: #fff;
	}

	.nav_pro {

		border-bottom: 1px solid #F2F2F2;
	}


	@media screen and (max-width:1200px) {

		.header_head .logo {
			width: 20%;
			text-align: center;
			margin-top: 15px;
			margin-right: 5%;
		}

		.header_head .logo img {
			width: 120px;
		}

		.header_head .serch {
			width: 50%;
			margin: 0px 2%;
			margin: 0px;
			padding: 0px 2%;
			margin-top: 10px;
		}

		.header_head .lang {
			width: 15%;
			float: right;
			margin-top: 20px;
		}

		.nav ul li {
			width: 33%;
			margin: 0px auto;
			text-align: center;
			text-align: center;
		}

		.c_banner {
			height: 150px;
		}

		.groups_list {
			padding: 20px 0;
		}

		.groups_list .item {
			width: 100%;
			margin-bottom: 25px;
		}

		.groups_list .item .dm .con {
			padding-right: 0px;
		}

		.groups_list .item .dm .con .icon {
			display: none;
		}
	}


	.zzxx {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 99;
	}

	#Loading {
		top: 50%;
		left: 50%;
		position: fixed;
		-webkit-transform: translateY(-50%) translateX(-50%);
		transform: translateY(-50%) translateX(-50%);
		z-index: 100;
	}

	@-webkit-keyframes ball-beat {
		50% {
			opacity: 0.2;
			-webkit-transform: scale(0.75);
			transform: scale(0.75);
		}

		100% {
			opacity: 1;
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}

	@keyframes ball-beat {
		50% {
			opacity: 0.2;
			-webkit-transform: scale(0.75);
			transform: scale(0.75);
		}

		100% {
			opacity: 1;
			-webkit-transform: scale(1);
			transform: scale(1);
		}
	}

	.ball-beat>div {
		background-color: #5D9BFF;
		width: 15px;
		height: 15px;
		border-radius: 100% !important;
		margin: 2px;
		-webkit-animation-fill-mode: both;
		animation-fill-mode: both;
		display: inline-block;
		-webkit-animation: ball-beat 0.7s 0s infinite linear;
		animation: ball-beat 0.7s 0s infinite linear;
	}

	.ball-beat>div:nth-child(2n-1) {
		-webkit-animation-delay: 0.35s !important;
		animation-delay: 0.35s !important;
	}
</style>
